import React, { Component } from 'react'
import Select from "react-select";
import { Modal, Button, Col, Row, Form, ToggleButton, ButtonGroup, Table } from "react-bootstrap-v5";
import helperFunction from '../../../../Function/helperFunction'
import MasterService from "../../../../Services/masterService";
import EnquiryService from "../../../../Services/EnquiryService";

const DECIMALLENGTH = 3

class PackageModal extends Component {
    constructor(props) {
        super(props)
        this.itemFreight = []
        this.itemPrice = []
        this.state = {
            showModal: false,
            packing: [],
            packingValue: 1,
            packingValueForAll: '',
            packaginTypes: [],
            charges: 0,
            freight: 0,
            originData: {},
            destinationData: {},
            bookedItems: [],
            bookingAmount: this.props.itemsBookingAmount
        }
    }

    componentDidMount = () => {
        MasterService.get_package().then((result) => {
            if (result.status === true) {
                const { packingItem } = this.props
                let tempCopy = JSON.parse(JSON.stringify(packingItem))

                let packingOpt = [{ value: 'NONE', label: 'NONE' }]

                // separate actual itets data and save in state
                let actualItems = tempCopy.length && tempCopy.map(item => item.actual)

                let packingTypeSel = packingItem.map(item => item.add_ons_items.packing_type)
                this.itemPrice = packingItem.map(item => item.add_ons_items.packing_charges)
                this.itemFreight = packingItem.map(item => item.add_ons_items.freight_charges)

                result.data.packings.map(item => packingOpt.push({ value: item.packing_type, label: item.packing_type }))

                if (packingItem !== undefined || packingItem.length > 0) {
                    let ch = packingItem.reduce((total, item) => Number(item.add_ons_items.packing_charges) + total, 0)
                    let frt = packingItem.reduce((total, item) => Number(item.add_ons_items.freight_charges) + total, 0)

                    this.setState({
                        packaginTypes: packingOpt,
                        packing: packingTypeSel,
                        bookedItems: actualItems,
                        charges: ch,
                        freight: frt,
                    })
                }
            }
        });
    }

    setToggleButtonValue = (value) => {
        this.setState({ packingValue: value })
    }

    setPackValue = (e) => {
        const { packingItem } = this.props

        packingItem.map(async (item, index) => {
            setTimeout(() => {
                this.handleInputChage(
                    { value: e.target.value },
                    index,
                    'packing_type'
                )
              }, (index + 1) * 2000)
            
        })
    }

    handleInputChage = async (event, index, selType) => {
        const { value } = event;
        let list = this.state.packing;
        let bookedItems = this.state.bookedItems;
        
        let tempCopy = JSON.parse(JSON.stringify(this.props.packingItem))

        // separate actual items data
        let actualItemOriginal = tempCopy.length && tempCopy.map(item => item.actual)

        bookedItems = actualItemOriginal  // Copy newly added item (from cargo), for matching new index

        if (value !== 'NONE') {

            list[index] = value // To show selected packing type

            let itemDimension = {
                length: actualItemOriginal[index]['length'],
                height: actualItemOriginal[index]['height'],
                width: actualItemOriginal[index]['width'],
                weight: actualItemOriginal[index]['kilogram'],
            }

            let type = helperFunction.toCamelCase(value);

            let actualUnit = helperFunction.calculateItem(itemDimension, type)
            let dap = helperFunction.dimensionAfterPacking(itemDimension, type) // dimension after packing
            let afterUnit = helperFunction.calculateItem(dap, type)
            let diff = (afterUnit - actualUnit)
            diff = diff.toFixed(DECIMALLENGTH)
            

            //----START---- This will be for freight calculation -----START---

            let weight = helperFunction.calculateWeight(itemDimension.weight, diff, type)

            let volume = helperFunction.calculateVolume(dap).toFixed(DECIMALLENGTH);

            bookedItems[index]['length'] = dap.length
            bookedItems[index]['height'] = dap.height
            bookedItems[index]['width'] = dap.width
            bookedItems[index]['kilogram'] = Number(weight)
            bookedItems[index]['packing_type'] = value
            bookedItems[index]['total_volume_CBM'] = volume * Number(bookedItems[index]['no_of_pkgs'])
            bookedItems[index]['total_weight_KG'] = weight * Number(bookedItems[index]['no_of_pkgs'])

            //----END---- This will be for freight calculation -----END---

            let chgs = helperFunction.calculatePrice(actualUnit, bookedItems[index]['no_of_pkgs'], type)

            bookedItems[index]['packing_charges'] = this.itemPrice[index] = chgs.toFixed(DECIMALLENGTH)

            bookedItems[index][selType] = value

            let totalCharges = bookedItems.reduce((total, item) => Number(item.packing_charges) + total, 0)

            return this.setState({ charges: totalCharges, bookedItems, packing: list }, async () => {
                return await this.setFreightAmt(index)
            });

        } else {
            const { packing, bookedItems } = this.state

            let packOpt = packing
            this.itemFreight[index] = 0
            this.itemPrice[index] = 0
            packOpt[index] = 'NONE'

            bookedItems[index] = actualItemOriginal[index] // If admin remove packing from item

            this.setState(() => {
                let tc = this.itemPrice.reduce((a, b) => Number(a) + Number(b))
                let tf = this.itemFreight.reduce((a, b) => Number(a) + Number(b))

                return {
                    charges: tc,
                    freight: tf,
                    packing: packOpt,
                    bookedItems
                }
            })
        }
    }

    setFinalBookingAmt = (frtAmt, index) => {
        const { bookedItems } = this.state
        // let balanceAmt = Number(frtAmt) - Number(this.state.bookingAmount)
        let balanceAmt = Number(frtAmt) - Number(this.props.paymentInformation.breakdown.freight)
        let finalBalanceAmt = 0
        this.itemFreight[index] = Number(balanceAmt.toFixed(3)) // set balance amount for perticular item
        bookedItems[index]['freight_charges'] = this.itemFreight[index]
        finalBalanceAmt = this.itemFreight.reduce((a, b) => Number(a) + Number(b)) // get total frieght
        let price = this.itemPrice.reduce((a, b) => Number(a) + Number(b)) // get total frieght
        let fb = finalBalanceAmt.toFixed(3)
        this.setState({ freight: Number(fb), charges: price })
        return true
    }

    setFreightAmt = async (index) => {
        const { bookedItems } = this.state
        const { jobShipmentData, jobCargoData, originData, destinationData, packingItem, quoteToken } = this.props

        if (originData.length == 0 || destinationData.length == 0) return false

        let tempCopy = JSON.parse(JSON.stringify(this.props.packingItem))

        // separate actual items data
        let actualItemOriginal = tempCopy.length && tempCopy.map(item => item.actual)
        let totalPackages = bookedItems.reduce((total, item) => Number(item.no_of_pkgs) + total, 0)

        let totalVolume = bookedItems.reduce((total, item, currIndex) => {
            let tv = index === currIndex ? (Number(item.total_volume_CBM)) : Number(actualItemOriginal[currIndex].total_volume_CBM)
            return tv + total
        }, 0)

        let totalWeight = bookedItems.reduce((total, item, currIndex) => {
            let tw = index === currIndex ? (Number(item.total_weight_KG)) : Number(actualItemOriginal[currIndex].total_weight_KG)
            return tw + total
        }, 0)

        let shipType = jobShipmentData.service_type === undefined ? jobShipmentData.shipment_mode : jobShipmentData.service_type.concat(jobShipmentData.shipment_mode)

        let items = bookedItems.map((item, idx) => {

            let sendItem = index === idx ? item : actualItemOriginal[idx]

            return {
                "item_id": "",
                "item_description": item.item_description,
                "no_of_pkgs": item.no_of_pkgs,
                "dimension": {
                    "kilogram": sendItem.kilogram,
                    "length": sendItem.length,
                    "width": sendItem.width,
                    "height": sendItem.height,
                },

                "total_volume_CBM": sendItem.total_volume_CBM,
                "total_weight_KG": sendItem.total_weight_KG,
                "item_token": packingItem[idx].item_token
            }

        })
        let valOfGood = jobShipmentData.actual_value_of_goods ? jobShipmentData.actual_value_of_goods : jobShipmentData.value_of_goods
        let postData = {
            origin_country: originData.origin_country,
            origin_country_short_name: originData.origin_country_short_name,
            origin_city: originData.origin_city,
            origin_latitude: originData.origin_latitude,
            origin_longitude: originData.origin_longitude,
            destination_country: destinationData.origin_country,
            destination_country_short_name: destinationData.origin_country_short_name,
            destination_city: destinationData.origin_city,
            destination_latitude: destinationData.origin_latitude,
            destination_longitude: destinationData.origin_longitude,

            number_of_packages: totalPackages,
            volume: Number(totalVolume.toFixed(DECIMALLENGTH)),
            weight: Number(totalWeight.toFixed(DECIMALLENGTH)),
            items_goods: Number(valOfGood),

            items: items,
            quote_token: quoteToken,
            referral_token: '',
            promo_code: '',
        }

        let getFinalQuotezKey;
        let sType = jobShipmentData.hasOwnProperty('servic_type') ? jobShipmentData.servic_type : jobShipmentData.service_type;

        if (sType.includes("PORT")) getFinalQuotezKey = 'port_delivery'
        if (sType.includes("DOOR")) getFinalQuotezKey = 'door_delivery'
        if (sType.includes("CONSOLIDATION")) getFinalQuotezKey = 'consolidation_delivery'

        let k = getFinalQuotezKey.replace('_delivery', '');
        
        if(shipType.includes('AIR')) {
            return  EnquiryService.postCheckAirQuote(postData).then((result) => {
                if (result.status === true) {
                    let frtAmt = result.all_data.final[getFinalQuotezKey][`discount_${k}_grant_total`]
                    return this.setFinalBookingAmt(frtAmt, index)
                }
            });
        }

        if(shipType.includes('SEA') ) {
            return EnquiryService.postCheckSeaQuote(postData).then((result) => {

                if (result.status === true) {
                    let frtAmt = result.all_data.final[getFinalQuotezKey][`discount_${k}_grant_total`]
                    return this.setFinalBookingAmt(frtAmt, index)
                }
            });
        }

        if(shipType.includes('COURIER')) {
            return EnquiryService.postCheckCourierQuote(postData).then((result) => {
                if (result.status === true) {
                    let frtAmt = result.all_data.door_delivery.discount_door_grant_total
                    return this.setFinalBookingAmt(frtAmt, index)
                }
            });
        }

        if(shipType.includes('LAND')) {
            return EnquiryService.postCheckLandQuote(postData).then((result) => {

                if (result.status === true) {
                    let frtAmt = result.all_data.final[getFinalQuotezKey][`discount_${k}_grant_total`]
                    return this.setFinalBookingAmt(frtAmt, index)
                }
            });
        }
    }

    handleShow = (value) => this.setState({ showModal: value })

    saveAddOne = () => {
        const { charges, freight, bookedItems, packing } = this.state
        let items = this.props.packingItem

        bookedItems.length && bookedItems.map((item, index) => {
            item.packing_charges = Number(this.itemPrice[index])
            item.freight_charges = Number(this.itemFreight[index])
            item.packing_type = packing[index]
            items[index]['add_ons_items'] = item
        })

        this.handleShow(false)
        // For actual amount, to be set in payment information
        this.props.manageActualAmt(Number(charges), Number(freight))
        this.props.onChangePack({ value: items }, 'quote_request_items', 'quote_request_items')
        
    }

    render() {

        const { packing, packingValue, packaginTypes, charges, freight, bookedItems } = this.state
        const { packingItem } = this.props

        if (!packingItem || Object.keys(packingItem).length === 0) return false

        return (
            <>
            {!this.props.isview && 
                <Button variant="primary" onClick={() => this.handleShow(true)}>
                    Add or View packing
                </Button>
            }

                <Modal show={this.state.showModal} onHide={() => this.handleShow(false)} dialogClassName="modal-90w">
                    <Modal.Header closeButton>
                        <Modal.Title>Packing</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Row className="justify-content-md-center">
                            <Col>
                                <ButtonGroup className="mb-2">
                                    <ToggleButton
                                        id='radio-1'
                                        type="radio"
                                        value={1}
                                        name="radio"
                                        variant={packingValue == 1 ? 'success' : 'secondary'}
                                        checked={packingValue === 1}
                                        onChange={(e) => this.setToggleButtonValue(e.currentTarget.value)}
                                    >
                                        Different Packing For All
                                    </ToggleButton>
                                    <ToggleButton
                                        id='radio-2'
                                        type="radio"
                                        value={2}
                                        name="radio"
                                        variant={packingValue == 2 ? 'success' : 'secondary'}
                                        checked={packingValue === 2}
                                        onChange={(e) => this.setToggleButtonValue(e.currentTarget.value)}
                                    >
                                        Same Packing For All
                                    </ToggleButton>
                                </ButtonGroup>

                                {/* Display packings */}
                                {packingValue == 2 && <div className="mb-3">
                                    {packaginTypes.map((item) => (
                                        <Form.Check
                                            style={{ textTransform: 'capitalize' }}
                                            inline
                                            label={item.value}
                                            value={item.value}
                                            name="group1"
                                            type="radio"
                                            id={`inline-${item}-1`}
                                            onChange={(e) => this.setPackValue(e)}
                                        />
                                    ))}
                                </div>}
                            </Col>
                        </Row>
                        <Row className="justify-content-md-center">
                            <Col>
                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th rowSpan="2">S.No.</th>
                                            <th rowSpan="2">Product Description</th>
                                            <th rowSpan="2">Pkgs (No.)</th>
                                            <th colSpan="4">Weight & Dimension per Package</th>
                                            <th >Packing Type </th>
                                            <th width="50">Packing Charges</th>
                                            <th width="50">Freight Charges</th>
                                        </tr>
                                        <tr>
                                            <th>Kilogram</th>
                                            <th>Length</th>
                                            <th>width</th>
                                            <th>Height</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            packingItem
                                            && packingItem.length > 0
                                            && packingItem.map((item, index) => {
                                                
                                                let packType = packingItem[index].add_ons_items && packingItem[index].add_ons_items.packing_type ? packingItem[index].add_ons_items.packing_type : ""

                                                if(
                                                    item.actual.kilogram === 0
                                                    || item.actual.length === 0
                                                    || item.actual.width === 0
                                                    || item.actual.height === 0
                                                    || item.actual.no_of_pkgs === 0
                                                ){
                                                    return false
                                                } else
                                                return <tr>
                                                    <td>{index + 1}</td>
                                                    <td>{item.actual.item_description}</td>
                                                    <td>{item.actual.no_of_pkgs}</td>
                                                    <td>{item.actual.kilogram}</td>
                                                    <td>{item.actual.length}</td>
                                                    <td>{item.actual.width}</td>
                                                    <td>{item.actual.height}</td>
                                                    <td>
                                                        <Select
                                                            options={packaginTypes}
                                                            name="packing_type"

                                                            value={
                                                                packing[index] !== undefined
                                                                    ?
                                                                    {
                                                                        value: packing[index],
                                                                        label: packing[index]
                                                                    }
                                                                    :
                                                                    {
                                                                        value: packType,
                                                                        label: packType
                                                                    }

                                                            }

                                                            onChange={(e) => this.handleInputChage(e, index, 'packing_type')}
                                                        />
                                                    </td>

                                                    <td>
                                                        {this.itemPrice[index]}
                                                    </td>
                                                    <td>
                                                        {this.itemFreight[index]}
                                                    </td>
                                                </tr>
                                            })
                                        }

                                    </tbody>
                                </Table>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={4}>
                                <p>Total Packing charges: {Number(charges) + Number(freight)}</p>
                                {/* <p>Freight charge: {freight}</p> */}
                            </Col>
                            <Col md={{ span: 4, offset: 4 }}>
                                <Button variant="primary" onClick={() => this.saveAddOne()}>
                                    Save Changes
                                </Button>
                            </Col>
                        </Row>

                    </Modal.Body>

                </Modal>
            </>
        )
    }
}

export default PackageModal